import { FolderTreeItem } from "../useQueryFolderTree";
import { alphabetizeFolders } from "./alphabetizeFolders";

// Insert folder tree item into the tree recursively -> https://stackoverflow.com/a/62180005
export const insertFolderIntoTree = (
  object: FolderTreeItem | FolderTreeItem[],
  element: FolderTreeItem,
): any => {
  if (Array.isArray(object)) {
    // 1. If parentId exists on the tree item, then recursively go into the tree
    return element.parentId
      ? (object as FolderTreeItem[]).map((o: FolderTreeItem) =>
          insertFolderIntoTree(o, element),
        )
      : alphabetizeFolders([...object, element]); // 2. If parentId doesn't exist then it is a root folder and append it to the array then sort it
    // The folder has a parentId, find it's parent
  } else if (String(object.id) === String(element.parentId)) {
    // add the element into the parent's children
    return {
      ...object,
      children: [...(object.children || []), element].sort((a, b) =>
        (a as FolderTreeItem).name.localeCompare((b as FolderTreeItem).name),
      ),
    };
  } else {
    // recursively go down each treeitem's children
    return {
      ...object,
      ...("children" in object
        ? {
            children: insertFolderIntoTree(
              object.children as FolderTreeItem | FolderTreeItem[],
              element,
            ),
          }
        : {}),
    };
  }
};
